/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";

const useFunilStatusGrupo = (formikRef) => {
  const funilStatusGrupoSelect = useSelect("funilStatusGrupo");
  const [funilStatusGrupo, setFunilStatusGrupo] = useState(0);
  const [funilStatusGrupoSelecionado, setFunilStatusGrupoSelecionado] = useState(0);

  const [funilStatusGrupoList, setFunilStatusGrupoList] = useState([]);

  useEffect(() => {
    const fetchFunilStatusGrupoList = async () => {
      const result = [];
      await db.funilStatusGrupo
        .orderBy("prioridade")
        .filter((a) => a.ativo)
        .each((item) => result.push(item));
      setFunilStatusGrupoList(result);
    };

    fetchFunilStatusGrupoList();
  }, []);
  const optionFunisStatusGrupo = useMemo(() => prepareForOptions(funilStatusGrupoList, "nome", "id"), [funilStatusGrupoList]);

  function onChangeFunilStatusGrupo(e) {
    funilStatusGrupoSelect.upDateValue(e.value);
    funilStatusGrupoSelect.upDateDefaultValue(e || "");
    if (formikRef?.current) {
      formikRef.current.setFieldValue("funilStatusGrupoId", e.value);
      setTimeout(() => formikRef.current.setFieldTouched("funilStatusGrupoId", true));
    }
    const funilStatusGrupoSel = funilStatusGrupoList.find(fs => fs.id === e.value);
    setFunilStatusGrupoSelecionado(funilStatusGrupoSel);
    setFunilStatusGrupo(e.value);
  }

  function SetSelectFunilStatusGrupo(id) {
    const funilStatusGrupoOption = optionFunisStatusGrupo.find(funilStatusGrupo => funilStatusGrupo.value === id);
    if (funilStatusGrupoOption)
      onChangeFunilStatusGrupo(funilStatusGrupoOption);
  }

  return {
    funilStatusGrupoList,
    optionFunisStatusGrupo,
    funilStatusGrupoSelecionado,
    onChangeFunilStatusGrupo,
    funilStatusGrupo,
    funilStatusGrupoSelect,
    setFunilStatusGrupo,
    SetSelectFunilStatusGrupo
  };
};

export default useFunilStatusGrupo;